import { Module } from 'vuex'
import { GlobalDataProps, actionWrapper } from './index'
import { ListData, RespData } from './respTypes'

export interface ResumeData {
  _id: string;
  name: string;
  uuid: string;
  desc?: string;
  coverImg?: string;
  createdAt: string;
  updatedAt: string;
  config: EditorConfig;
  data: {
    basicInfo: BasicInfoProps;
    sections: SectionProps[];
    links: LinkDataProps[];
  },
  userId: any;
  category?: string;
  isExamples?: boolean;
  disabled?: boolean;
}
export interface BasicInfoProps {
  title: string;
  name: string;
  avatar: string;
  location: string;
  cellphone: string;
  email: string;
  birth: string;
}
export interface LinkDataProps {
  name: string;
  src: string;
  isNew?: boolean;
}
export interface SectionDataProps {
  title: string;
  subTitle?: string;
  startDate?: string;
  endDate?: string;
  city?: string;
  description?: string;
  isNew?: boolean;
}
export type SectionType =  'empolyment' | 'education' | 'skills' | 'custom'
export interface SectionProps {
  id: string;
  name: string;
  type: SectionType;
  data: SectionDataProps[];
  isCreated?: boolean;
}
export interface EditorConfig {
  templateName: string;
  templateTheme: string;
  isPublic: boolean;
  customURL: string;
  cellphoneIsHidden: boolean;
  emailIsHidden: boolean;
  removeBranding: boolean;
  addToExamples: boolean;
}
export interface ResumeProps {
  data: ResumeData[];
  isLoaded: boolean;
  count: number;
}
const resume: Module<ResumeProps, GlobalDataProps> = {
  state: {
    data: [],
    isLoaded: false,
    count: 0
  },
  mutations: {
    getResumes(state, rawData: ListData<ResumeData[]>) {
      const { data } = rawData
      state.data = data.data
      state.isLoaded = true
    },
    getResumesAdmin(state, rawData: ListData<ResumeData[]>) {
      const { data, count } = rawData.data
      state.data = data
      state.count = count
      state.isLoaded = true
    },
    getResume(state, rawData: RespData<ResumeData>) {
      const { data } = rawData
      const index = state.data.findIndex(resume => resume._id === data._id)
      if (index > -1) {
        state.data[index] = data
      } else {
        state.data.push(data)
      }
    },
    createResume(state, rawData: RespData<ResumeData>) {
      const { data } = rawData
      state.data.push(data)
    },
    createResumeAdmin(state, rawData: RespData<ResumeData>) {
      const { data } = rawData
      state.data.unshift(data)
    },
    copyResume(state, rawData: RespData<ResumeData>) {
      const { data } = rawData
      state.data.push(data)
    },
    updateResume(state,  payload: RespData<ResumeData>) {
      console.log(1234, payload)
      const { data } = payload
      const index = state.data.findIndex(resume => resume._id === data._id)
      if (index > -1) {
        state.data[index] = data
      }
    },
    deleteResume(state, { payload }: RespData<any>) {
      if (payload && payload.urlParams) {
        const { urlParams } = payload
        state.data = state.data.filter(resume => resume._id !== urlParams.id)
      }
    },
    saveEditor(state, payload: ResumeData) {
      const updatedItem = state.data.find(resume => resume._id === payload._id)
      console.log('payload in resume', payload)
      const { coverImg, updatedAt, name} = payload
      if (updatedItem) {
        updatedItem.name = name
        updatedItem.coverImg = coverImg
        updatedItem.updatedAt = updatedAt
      }
    }
  },
  actions: {
    getResumes: actionWrapper('/api/resumes', 'getResumes'),
    getResumesAdmin: actionWrapper('/api/resumesAdmin', 'getResumesAdmin', { disableCaching: true }),
    getResume: actionWrapper('/api/resumes/:id', 'getResume', { disableCaching: true }),
    createResumeAdmin: actionWrapper('/api/resumes/', 'createResumeAdmin', { method: 'post', disableCaching: true }),
    createResume: actionWrapper('/api/resumes/empty', 'createResume', { method: 'post', disableCaching: true }),
    copyResume: actionWrapper('/api/resumes/copy/:id', 'copyResume', { method: 'post', disableCaching: true }),
    updateResume: actionWrapper('/api/resumes/:id', 'updateResume', { method: 'patch', disableCaching: true }),
    deleteResume: actionWrapper('/api/resumes/:id', 'deleteResume', { method: 'delete', disableCaching: true })
  }
}

export default resume